<template>
  <div :class="`si-center-card ${type} ${bgColor}`">
    <div class="si-center-card__title" v-if="title">
      <r-cblock v-if="titleIcon" :size="24" :color="titleIcon.color">
        <r-icon :name="titleIcon.name" :size="18" :color="titleIcon.color" />
      </r-cblock>
      <r-title type="subtitle-1">{{ $t(title) }}</r-title>
    </div>
    <el-divider v-if="title && !noDeviders" />
    <div class="si-center-card__content">
      <slot />
    </div>
    <el-divider v-if="footer && !noDeviders" />
    <div class="si-center-card__footer" v-if="footer">
      <slot name="footer" />
    </div>
    <el-divider v-if="secondFooter && !noDeviders" />
    <div class="si-center-card__second-footer" v-if="secondFooter">
      <slot name="second-footer" />
    </div>
    <div class="si-center-card__controls" v-if="controls">
      <slot name="controls" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    footer: {
      type: Boolean,
      default: false
    },
    secondFooter: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "default"
    },
    controls: {
      type: Boolean,
      default: false
    },
    titleIcon: {
      type: Object,
      default: null
    },
    noDeviders: {
      type: Boolean,
      default: false
    },
    bgColor: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss">
.si-center-card {
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  border-radius: var(--border-radius);
  background-color: var(--modal_bg) !important;
  box-shadow: 0px 3px 6px rgba(var(--black), 0.4);
  &.bg_panel_primary {
    background-color: var(--bg_panel_primary) !important;
  }
  .el-divider {
    margin: 0;
    background-color: var(--dividers_low_contrast) !important;
    min-height: 1px;
  }

  &__content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    flex: 1;
  }

  &__title {
    height: 19px;
    flex-shrink: 0;
    padding: 8px 8px 10px;
    margin: 0;
    text-transform: capitalize;
    display: flex;
    align-items: center;
    .r-cblock {
      margin-right: 12px;
      width: 44px;
    }
    .r-title {
      width: calc(100% - 56px);
    }
  }
  &__content,
  &__footer,
  &__second-footer {
    padding: 8px;
    position: relative;
  }

  &__controls {
    position: absolute;
    padding: 2px 8px;
    top: 1px;
    right: 0;
  }
}
</style>

<i18n>
{
  "ru": {
    "traffic_lights": "Светофоры",
    "chsmeo_traffic_light_count": "Светофоры",
    "pdk": "Камеры ПДК",
    "chsmeo_cams?format=stat": "Камеры ПДК",
    "road_engineering": "Дорожная техника",
    "chsmeo_wialon_tracks?format=stat": "Дорожная техника",
    "public_transport": "Общественный транспорт",
    "chsmeo_ngpt_count": "Общественный транспорт",
    "events": "События"
  },
  "en": {
    "traffic_lights": "Traffic lights",
    "chsmeo_traffic_light_count": "Traffic lights",
    "pdk": "PDK cameras",
    "chsmeo_cams?format=stat": "PDK cameras",
    "road_engineering": "Road engineering",
    "chsmeo_wialon_tracks?format=stat": "Road engineering",
    "public_transport": "Public transport",
    "chsmeo_ngpt_count": "Public transport",
    "events": "Events"
  }
}
</i18n>
